import { render, staticRenderFns } from "./OrgChartNode4.vue?vue&type=template&id=956483da&scoped=true&"
import script from "./OrgChartNode4.vue?vue&type=script&lang=js&"
export * from "./OrgChartNode4.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartNode4.vue?vue&type=style&index=0&id=956483da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956483da",
  null
  
)

export default component.exports